<template>
  <div class="bg-overlay left-0 top-0 absolute w-full h-full flex justify-center items-center">
    <div>
      <div class="text-center pb-16 text-white px-8 xl:px-0">
        <p class="font-oswald font-light text-5xl">
          Rise of Cultures Layout Builder
        </p>
        <p class="mt-4 text-sm">
          Select your era to begin
        </p>
      </div>
      <div class="flex flex-row flex-wrap xl:gap-2">
        <div
          v-for="era in eras"
          :key="era.id"
          :style="`background:url(${era.cover}) center center no-repeat;background-size:cover`"
          class="era-item leading-none text-center cursor-pointer w-1/2 xl:px-0 xl:py-0 xl:w-32 xl:h-72 flex flex-col justify-end rounded overflow-hidden relative bottom-0 hover:bottom-2 select-none"
          @click="selectEra(era.id)"
        >
          <span
            :class="{
              'bg-stone-age': era.id === 'stoneAge',
              'bg-bronze-age': era.id === 'bronzeAge',
              'bg-minoan-era': era.id === 'minoanEra',
              'bg-classic-greece': era.id === 'classicGreece',
              'bg-early-rome': era.id === 'earlyRome',
              'bg-roman-empire': era.id === 'romanEmpire',
              'bg-byzantine-era': era.id === 'byzantineEra',
              'bg-age-of-the-franks': era.id === 'ageOfTheFranks',
              'bg-feudal-age': era.id === 'feudalAge',
              'bg-iberian-era': era.id === 'iberianEra',
              'bg-kingdom-of-sicily': era.id === 'kingdomOfSicily',
              'bg-high-middle-ages': era.id === 'highMiddleAges',
              'bg-early-gothic-era': era.id === 'earlyGothicEra',
              'bg-late-gothic-era': era.id === 'lateGothicEra',
            }"
            class="text-white uppercase h-8 xl:h-16 leading-tight xl:leading-normal px-4 flex flex-col justify-center pointer-events-none font-oswald font-light"
          >
            {{ era.title }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Eras from '@/roc/era';
import {computed} from 'vue';

export default {
  emits: ['select'],
  setup(_, context) {
    return {
      eras: computed(() => {
        const result = [];
        for (const i in Eras) {
          result.push({
            id: i,
            title: Eras[i].name,
            cover: require('@/assets/images/era/' + i + '.webp')
          });
        }
        return result;
      }),

      selectEra (eraId) {
        context.emit('select', eraId);
      }
    };
  }
};
</script>

<style>
.era-item {
  transition: all 300ms ease-in-out;
}
</style>
